// extracted by mini-css-extract-plugin
export default {"container":"RotateScreen__container--oJWrI"};